import React from "react";

export default function WhoAttends() {
  return (
    <section id="who-attends" className="bg-under bg-purple">
      <div className="container">
        <div className="row text-center pt-4 pb-3">
          <div className="col-12 pb-4">
            <h2 className=" color-white">Who attends?</h2>
          </div>
          <div className="col-md-4 pb-4 px-2">
            <div className="bg-vertical-purple-fade bg-rounded">
              <span className="display-2 color-white">70%</span>
              <p className=" color-white">C-Suite &amp; V-Suite</p>
            </div>
          </div>
          <div className="col-md-4 pb-4 px-2">
            <div className="bg-vertical-purple-fade bg-rounded">
              <span className="display-2 color-white">20%</span>
              <p className=" color-white">
                HR Generalists, Specialists &amp; Directors
              </p>
            </div>
          </div>
          <div className="col-md-4 pb-4 px-2">
            <div className="bg-vertical-purple-fade bg-rounded">
              <span className="display-2 color-white">10%</span>
              <p className=" color-white">Compensation &amp; Benefits</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
